import { Box } from "@material-ui/core"
import type { ReactChild, ReactElement } from "react"

export interface ITabContentContainerProps {
  activeTab: number
  children: ReactChild[] | ReactElement[]
}

export function TabContentContainer(props: ITabContentContainerProps): ReactElement {
  const { activeTab, children } = props

  return <Box className="tab-content-container">{children[activeTab]}</Box>
}
